export default "__VITE_ASSET__gYWSPz4k__"